import React from 'react';
import { CheckIcon } from 'lucide-react';
type Group = {
  title: string;
  items: string[];
};
export function ServiceGroups({
  groups,
  columns = 4
}: {
  groups: Group[];
  columns?: 2 | 3 | 4;
}) {
  const grid = columns === 2 ? 'md:grid-cols-2' : columns === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2 lg:grid-cols-4';
  return <div className={`grid gap-x-10 gap-y-10 ${grid}`} data-id="element-490" data-mp="69wsu1v63ufm">
      {groups.map(group => <div key={group.title} className="border-t border-graphite-900/15 pt-5" data-id="element-491" data-mp="k1l3s1tokcv0">
          <h3 className="font-display text-lg font-bold tracking-tight text-graphite-900" data-id="element-492" data-mp="g1aq02znci5l">{group.title}</h3>
          <ul className="mt-4 space-y-2.5" data-id="element-493" data-mp="u0sjgvnw0jla">
            {group.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-relaxed text-graphite-500" data-id="element-494" data-mp="p1pflejn8jew">
                <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-brand-500" aria-hidden="true" data-id="element-495" data-mp="2vrnkq30v5aze" />
                <span data-id="element-496" data-mp="2qtc7rjf9ukcy">{item}</span>
              </li>)}
          </ul>
        </div>)}
    </div>;
}
export function ServiceList({
  items,
  tone = 'light'
}: {
  items: string[];
  tone?: 'light' | 'dark';
}) {
  return <ul className="grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-497" data-mp="4rqj0smynezv">
      {items.map(item => <li key={item} className={`flex gap-2.5 text-sm leading-relaxed ${tone === 'dark' ? 'text-mist-200' : 'text-graphite-500'}`} data-id="element-498" data-mp="8rhh7hetgxef">
          <CheckIcon className={`mt-1 h-3.5 w-3.5 shrink-0 ${tone === 'dark' ? 'text-accent-400' : 'text-brand-500'}`} aria-hidden="true" data-id="element-499" data-mp="iic1ig8i5mx8" />
          <span data-id="element-500" data-mp="njjd6qdrn696">{item}</span>
        </li>)}
    </ul>;
}